import React from 'react';
import '../../style/css/riboa.css'
import iconcloseriboa from '../../style/icons/cancel.svg'
import iconconfirmriboa from '../../style/icons/check.svg'

const Riboahp = () => {
    return (
        <div className={'riboa-container'}>
            <div className={'riboa-title'}>
                <div className={'title-1 bolder'}>18:30</div>
                <div className={'title-2'}><img alt={'סגור'} className={'icon-close-riboa'} src={iconcloseriboa}/></div>
            </div>
            <div className={'riboa-mid'}>
                <div className={'mid-1 bolder'}>401</div>
                <div className={'mid-2'}>בר מלצרים</div>
            </div>
            <div className={'riboa-footer'}>
                <div className={'footer-1 bolder'}>7P</div>
                <div className={'footer-2'}>יובל בן שאול</div>
                <div className={'footer-3'}><img alt={'אישור'} className={'icon-confirm-riboa'} src={iconconfirmriboa}/>
                </div>
            </div>
        </div>
    );
};

export default Riboahp;